import { useState, useRef, useEffect, useCallback } from 'react'
import classNames from 'classnames'
import './GiftNote.scss'
import { giftNoteManager } from '../../../services/GiftNoteManager'
import useOnMount from 'hooks/useOnMount'
import { useUserDeviceData } from 'services/UserDeviceContext'
import { useTranslation } from 'react-i18next'

function GiftNote({ editing, note, onClick, onChange }) {
  const { isMobile, isTablet } = useUserDeviceData()
  const { t } = useTranslation()
  const [flipped, setFlipped] = useState(false)
  const [entryPosition, setEntryPosition] = useState(
    () => !giftNoteManager.getGiftNote()
  )
  const textareaRef = useRef(null)

  useOnMount(() => {
    if (entryPosition) {
      const timeout = setTimeout(() => setEntryPosition(false), 500)
      return () => clearTimeout(timeout)
    }
  })

  useOnMount(() => {
    const timeout = setTimeout(() => setFlipped(true), 1000)
    return () => clearTimeout(timeout)
  })

  const triggerFocus = useCallback(() => {
    const handleScroll = () => {
      window.scrollTo(0, 0)
      window.removeEventListener('scroll', handleScroll)
    }

    textareaRef.current.focus()
    // When focusing, prevent the automatic textarea scrolling and scroll to the top of the page instead.
    window.addEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    if (editing) {
      textareaRef.current.selectionStart = textareaRef.current.value.length
      textareaRef.current.selectionEnd = textareaRef.current.value.length
    }
  }, [editing])
  useEffect(() => {
    if (editing) {
      triggerFocus()
    }
  })

  const handleChange = (event) => {
    while (
      textareaRef.current.clientHeight < textareaRef.current.scrollHeight
    ) {
      textareaRef.current.value = textareaRef.current.value.slice(
        0,
        textareaRef.current.value.length - 1
      )
    }
    onChange(event)
  }

  return (
    <div
      className={classNames('gift-note-container', {
        'entry-position': entryPosition,
      })}
    >
      <div
        className={classNames('flip-container', {
          flipped: flipped || !!note,
          editing,
          mobile: isMobile || isTablet,
        })}
      >
        <div className="flipper">
          <div className="cover" />
          <div className="message" onClick={onClick}>
            <textarea
              ref={textareaRef}
              value={note || ''}
              maxLength={400} // this is here to prevent from pasting large amounts of chars
              onChange={handleChange}
              data-testid="gift-note-textarea"
            />
            {!note && (
              <pre
                style={{
                  pointerEvents: 'none',
                  position: 'absolute',
                }}
              >
                {t('order.checkout.add_gift_note_options.placeholder')}
              </pre>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default GiftNote
